import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import numeral from 'numeral';
import Spinner from 'react-spinner-material';
import { BarLoader } from 'react-spinners';
import { motion, AnimatePresence } from "framer-motion";
import moment from 'moment';

import styled from 'styled-components';

import ActionButton from 'SharedComponents/action-button';
//import ModalDialogV3 from 'SharedComponents/modal-dialog-v3';
import PopoverHover from 'SharedComponents/popover-hover';
import Formsy, { withFormsy } from 'formsy-react'; // Import withFormsy
import TextInput from 'SharedComponents/text-input';
//import PromoCodePurchaseButton from 'SharedComponents/promo-code-purchase-button';

import log from "Utils/logger";

//import * as SubscriptionActions from 'Flux/subscriptions/actions';
//import * as AuthenticationActions from 'Flux/authentication/actions';

import useCheckPromoCode from 'SharedHooks/check-promo-code';
import useActivatePromoCode from 'SharedHooks/activate-promo-code';
import useFetchActivePromoCodes from 'SharedHooks/fetch-shopper-promo-codes';
import useUpdateSubscription from 'SharedHooks/update-subscription';
//import useFetchSubscriptions from 'SharedHooks/fetch-subscriptions';

import styles from './index.css';

// Define default format for numbers in numeral
numeral.defaultFormat('0,0.00');

// Set default format for nulls
numeral.nullFormat('0.00');
numeral.zeroFormat('0.00');


const PromoCodeActivationWrapper = styled.div`${styles}`;

const TextInputWithFormsy = withFormsy(TextInput);

const PromoCodeActivation = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //The selectedPlan is initially undefined if a refreshis done.
  const selectedPlan = useSelector(state =>
    state.subscriptions.availSubscriptionPlans.find(plan => plan.subscriptionOptionSelected)
  );

  const activePlan = useSelector(state =>
    state.subscriptions.availSubscriptionPlans.find(plan => plan.shopperSubscribed)
  );

  const isEmployerPlan = useSelector(state => {
    const plan = state.subscriptions.availSubscriptionPlans.find(p => p.subscriptionOptionSelected);
    return plan?.subscriptionName?.toLowerCase().includes("employer") ?? false;
  });
 
  console.log('PromoCodeActivation triggered with selectedPlan: ', selectedPlan);
  //console.log('PromoCodeActivation triggered with selectedPlanValue: ', selectedPlanValue);

  const [isPromoCodeValid, setIsPromoCodeValid] = useState(false);
  const [roundUpCode, setRoundUpCode] = useState("");
  const [employerCode, setEmployerCode] = useState("");
  const [checkCode, setCheckCode] = useState("");
  const [activateOnClick, setActivateOnClick] = useState(false);
  const [validationError, setValidationError] = useState('');
  const [activeRoundUpCode, setActiveRoundUpCode] = useState({});
  const [activeEmployerCode, setActiveEmployerCode] = useState({});
  const [activationMessage, setActivationMessage] = useState(''); //not sure we need this. It is for button message if need be.

  const isActiveEmployerCode = activeEmployerCode?.promo_type?.label === 'CONTRIBUTE_NOW'; 
  const isActiveRoundUpCode = activeRoundUpCode?.promo_type?.label === 'ROUNDUP'; // && activePromoCode?.active;

  const { updateSubscription } = useUpdateSubscription(); 

  const { fetchActivePromoCodes, fetchActivePromoCodesResponseRoundUps, fetchActivePromoCodesResponseContributeNow, isFetchingActivePromoCodesRef } = useFetchActivePromoCodes();

  const { checkPromoCode, checkCodeResponse, isCheckingPromoCode } = useCheckPromoCode(
    checkCode,
    isEmployerPlan ? 'contribute_now' : 'roundup',
    isEmployerPlan ? employerCode : roundUpCode
  );

  const { activatePromoCode, activateCodeResponse, isActivatingPromoCode } = useActivatePromoCode(
    checkCode,
    isEmployerPlan ? 'contribute_now' : 'roundup',
    isPromoCodeValid,
    activateOnClick
  );

  const debounceTimeoutRef = useRef(null);
  const formRef = useRef(null);

  useEffect(() => {
    //console.log('PromoCodeActivation useEffect triggered with availableSubscriptionPlans: ', availableSubscriptionPlans);

    console.log('PromoCodeActivation - mounted');
    return (() => {
      console.log('PromoCodeActivation - unmounted');
    });
  }, []);


  const onChangePromoCode2 = (event) => {
    const newPromoCode = event.target.value;
    console.log('1. onChangePromoCode2 triggered with newPromoCode: ', newPromoCode);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    
    debounceTimeoutRef.current = setTimeout(() => {
      setCheckCode(newPromoCode);
      if (newPromoCode.length < 2) {
      setIsPromoCodeValid(false);
      setValidationError('');
      }

    }, 700);
  };


  useEffect(() => {
    console.log('6.0 useEffect checkCodeResponse - promo response triggered with checkCodeResponse: ', checkCodeResponse);
      //if (!promoCode && checkCodeResponse?.valid && checkCodeResponse?.promo_code?.active && !checkCodeResponse?.promo_code?.shopper) {
      if (checkCodeResponse?.valid && checkCodeResponse?.promo_code?.active && !checkCodeResponse?.promo_code?.shopper) {
        console.log('6.1 checkCodeResponse VALID PROMO CODE FOUND');
        setIsPromoCodeValid(true);
        setValidationError('VALID');
      } else {
        console.log('6.1 checkCodeResponse VALID PROMO CODE NOT FOUND');
        setTimeout(() => {
          console.log('6.2 checkCodeResponse VALID PROMO CODE NOT FOUND - setting isPromoCodeValid to false');
          setIsPromoCodeValid(false);
          setValidationError('Invalid code');
        }, 400); // Delay setting the validation error by 500ms
      }
  }, [checkCodeResponse]);

  useEffect(() => {
    console.log('7.0 useEffect isCheckingPromoCode triggered with status: ', isCheckingPromoCode);
    if (isCheckingPromoCode) {
      setValidationError('checking...');
    }
  }, [isCheckingPromoCode]);

  useEffect(() => {
    console.log('8.0 useEffect fetchActivePromoCodesResponseRoundUps triggered with fetchActivePromoCodesResponseRoundUps: ', fetchActivePromoCodesResponseRoundUps);
    console.log('8.02 useEffect activateCodeResponse triggered with activateCodeResponse: ', activateCodeResponse);
    if (fetchActivePromoCodesResponseRoundUps && fetchActivePromoCodesResponseRoundUps.active && fetchActivePromoCodesResponseRoundUps.shopper.active) {
      console.log('8.1 useEffect fetchActivePromoCodesResponseRoundUps triggered with fetchActivePromoCodesResponseRoundUps: ', fetchActivePromoCodesResponseRoundUps);
      setActiveRoundUpCode(fetchActivePromoCodesResponseRoundUps);
      setRoundUpCode(fetchActivePromoCodesResponseRoundUps.code);
      console.log('8.11 useEffect fetchActivePromoCodesResponseRoundUps setting activeRoundUpCode: ', fetchActivePromoCodesResponseRoundUps);
    }
  },  [fetchActivePromoCodesResponseRoundUps ]);

  useEffect(() => {
    console.log('8.0 useEffect fetchActivePromoCodesResponseContributeNow triggered with fetchActivePromoCodesResponseContributeNow: ', fetchActivePromoCodesResponseContributeNow);
    console.log('8.02 useEffect activateCodeResponse triggered with activateCodeResponse: ', activateCodeResponse);
    if (fetchActivePromoCodesResponseContributeNow && fetchActivePromoCodesResponseContributeNow.active && fetchActivePromoCodesResponseContributeNow.shopper.active) {
      console.log('8.1 useEffect fetchActivePromoCodesResponseContributeNow triggered with fetchActivePromoCodesResponseContributeNow: ', fetchActivePromoCodesResponseContributeNow);
      setActiveEmployerCode(fetchActivePromoCodesResponseContributeNow);
      setEmployerCode(fetchActivePromoCodesResponseContributeNow.code);
      console.log('8.12 useEffect fetchActivePromoCodesResponseRoundUps setting activeEmployerCode: ', fetchActivePromoCodesResponseContributeNow);
    }
  },  [fetchActivePromoCodesResponseContributeNow ]);

  useEffect(() => {
    console.log('8.2 useEffect activateCodeResponse triggered with activateCodeResponse: ', activateCodeResponse);
    if (activateCodeResponse?.active 
      && activateCodeResponse?.shopper?.active
      ) {
      console.log('8.3 useEffect activateCodeResponse valid code triggered with activateCodeResponse: ', activateCodeResponse);
      if (isEmployerPlan) {
        console.log('8.31 useEffect activateCodeResponse valid code isEmployerPlan triggered with activateCodeResponse: ', activateCodeResponse);
        setActiveEmployerCode(activateCodeResponse);
        setEmployerCode(activateCodeResponse.code);
      } else {
        console.log('8.32 useEffect activateCodeResponse valid code isRoundUpPlan triggered with activateCodeResponse: ', activateCodeResponse);
        setActiveRoundUpCode(activateCodeResponse);
        setRoundUpCode(activateCodeResponse.code);
      }
      setValidationError('');
    } else if (activateCodeResponse?.valid === false || activateCodeResponse?.shopper.active === null) {
        console.log('8.4 useEffect activateCodeResponse code not valid activateCodeResponse: ', activateCodeResponse);
        setValidationError('Activation Error - try another code');
    }
  }, [activateCodeResponse]);


//test useEffect only. Can remove after back-end fixes response to promo.type coming back as null after activation.
  useEffect(() => {
    if (activeEmployerCode?.code) {
    console.log('useEffect PromoCodeActivation activate - activeEmployerCode changed to: ', activeEmployerCode);
    } else {
    console.log('useEffect PromoCodeActivation activate - activeRoundUpCode changed to: ', activeRoundUpCode);
    }
  }, [activeEmployerCode, activeRoundUpCode]);





  useEffect(() => {
    console.log('useEffect PromoCodeActivation - isEmployerPlan changed to isEmployerPlan: ', isEmployerPlan);
    console.log('useEffect PromoCodeActivation - isEmployerPlan changed activeEmployerCode: ', activeEmployerCode);
    console.log('useEffect PromoCodeActivation - isEmployerPlan changed activeRoundUpCode: ', activeRoundUpCode);
    console.log('useEffect PromoCodeActivation - isEmployerPlan changed checkCode: ', checkCode);
    console.log('useEffect PromoCodeActivation - isEmployerPlan changed validationError: ', validationError);

    console.log('useEffect PromoCodeActivation updated with selectedPlan: ', selectedPlan);
    console.log('useEffect PromoCodeActivation updated with activePlan: ', activePlan);
    console.log('useEffect PromoCodeActivation updated with isPromoCodeValid: ', isPromoCodeValid);
    console.log('useEffect PromoCodeActivation updated with isActiveEmployerCode: ', isActiveEmployerCode);
    console.log('useEffect PromoCodeActivation updated with isActiveRoundUpCode: ', isActiveRoundUpCode);
  
      if ( isEmployerPlan && !activeEmployerCode?.code ||
           !isEmployerPlan && !activeRoundUpCode?.code ||
           checkCode.length > 0 //this might be the only condition necessary?
          ) {
              console.log('useEffect PromoCodeActivation - isEmployerPlan changed - resetting checkCode, validationError');
              setCheckCode('');
              setValidationError('');
          }
  }, [isEmployerPlan]);

  const handleActivatePromoCode = () => {
    if (isPromoCodeValid) {
      setActivateOnClick(true);
    }
  };

  const handleUpdateSubscription = async () => {
    console.log('handleUpdateSubscriptions called with selectedPlan: ', selectedPlan);
    console.log('handleUpdateSubscriptions called with selectedPlan?.subscriptionID: ', selectedPlan?.subscriptionID);
    if (!selectedPlan?.subscriptionID) {
      console.log('No selected plan available for updateSubscription');
      return;
    }
    await updateSubscription(selectedPlan.subscriptionID);
  }

  const isActivePlanSelected = () => activePlan?.subscriptionID === selectedPlan?.subscriptionID;

  const handleClick = () => {
    const samePlan = isActivePlanSelected();
    const promoActive = !!(isEmployerPlan ? activeEmployerCode.code : activeRoundUpCode.code);

    if (samePlan && isPromoCodeValid && !promoActive) {
      console.log('handleClick - activating PromoCode');
      handleActivatePromoCode();
      return;
    }
  
    if (!samePlan) {
      console.log('handleUpdateSubscriptions - click Initiated');
      handleUpdateSubscription();
      console.log('handleClick - updating Subscription');
      if (isPromoCodeValid && !promoActive) {
        console.log('handleClick - activating PromoCode after updating Subscription');
        handleActivatePromoCode();
      }
    }
  };
  

  useEffect(() => {
    if (activateOnClick) {
      activatePromoCode();
      setActivateOnClick(false);
    }
  }, [activateOnClick]);

  
  const checkForIsPromoCodeValid = () => {
    return isPromoCodeValid;
  };

  const { resolvedInputValue, resolvedInputLabel, resolveInputDisabled, resolveActivateButton, resolveCodeDetails } = useMemo(() => {
    console.log("useMemo checking activate updates activeEmployerCode:", activeEmployerCode);
    const isZeroAmount = selectedPlan?.subscriptionAmount === 0;
    const activePlanSelected = activePlan?.subscriptionID === selectedPlan?.subscriptionID;

    if (isEmployerPlan) {
      const disableActivate = 
          activePlanSelected ||
          isActiveEmployerCode ||
          isCheckingPromoCode ||
          isActivatingPromoCode ||
          !selectedPlan?.subscriptionAvailable ||
          (!isActiveEmployerCode && validationError !== 'VALID');

          console.log('[Employer Plan] disableActivate reasons:', {
            activePlanSelected,
            isActiveEmployerCode,
            isCheckingPromoCode,
            isActivatingPromoCode,
            validationError,
            disableActivate
          });


      return {
        resolvedInputValue: isActiveEmployerCode
                            ? activeEmployerCode?.code
                            : checkCode,
        resolvedInputLabel: isActiveEmployerCode ? "Employer Code - Activated" : "Employer Code",
        resolveInputDisabled: isZeroAmount || isActiveEmployerCode ? true : false,
        resolveActivateButton:  !disableActivate,
        resolveCodeDetails: !isZeroAmount && (isActiveEmployerCode || !isActiveEmployerCode && validationError === 'VALID' && checkCode.length > 0)
      };

    } else {
      const disableActivate =
        (activePlanSelected && validationError !== 'VALID') ||
        isActiveEmployerCode ||
        //isActiveRoundUpCode || Don't use here!
        isCheckingPromoCode ||
        isActivatingPromoCode ||
        !selectedPlan?.subscriptionAvailable ||
        (checkCode.length > 0 && validationError !== 'VALID');

      console.log('[Non-Employer Plan] disableActivate reasons:', {
        activePlan,
        selectedPlan,
        activePlanSelected,
        isActiveEmployerCode,
        isActiveRoundUpCode,
        isCheckingPromoCode,
        isActivatingPromoCode,
        checkCodeLength: checkCode.length,
        validationError,
        disableActivate
      });
      return {
        resolvedInputValue: isActiveRoundUpCode
                            ? activeRoundUpCode?.code
                            : checkCode,
        resolvedInputLabel: isActiveRoundUpCode ? "Promo Code - Activated" : "Promo Code",
        resolveInputDisabled: isZeroAmount || isActiveEmployerCode || isActiveRoundUpCode ? true : false,
        resolveActivateButton:  !disableActivate,
        resolveCodeDetails: !isZeroAmount && (isActiveRoundUpCode || !isActiveRoundUpCode && validationError === 'VALID' && checkCode.length > 0)
     };
    }

  }, [
    activeRoundUpCode,
    activeEmployerCode,
    selectedPlan,
    activePlan,
    isPromoCodeValid,
    checkCode,
    validationError,
    isEmployerPlan,
    isCheckingPromoCode,
    isActivatingPromoCode,
    //isActiveEmployerCode,
    //isActiveRoundUpCode
  ]);

  const renderPromoCodeDetails = () => {
    const activeCode = isEmployerPlan ? activeEmployerCode : activeRoundUpCode;
    const isEmployer = selectedPlan?.subscriptionName.toLowerCase().includes("employer");
    const promoDesc = activeCode?.description || checkCodeResponse?.promo_code?.description;
    const endDate = activeCode?.shopper?.end_date || checkCodeResponse?.promo_code?.shopper?.end_date;
  
    return (
      <ul>
        <li>  <b>Rate to you with code (inc GST):&nbsp;</b> 
            { 
              activeCode?.description
              ? <span> <del style={{ color: "red" }}>{`AU $${numeral(selectedPlan?.subscriptionAmount).format()} ${selectedPlan?.subscriptionPeriod}`} </del>&nbsp; {`AU $ ${numeral((1-activeCode.discount_percentage*.01)*selectedPlan?.subscriptionAmount).format()} ${selectedPlan?.subscriptionPeriod}`}</span>
              : isPromoCodeValid && checkCodeResponse?.promo_code?.discount_percentage
              ? <span> <del style={{color:"red" }}>{`AU $ ${numeral(selectedPlan?.subscriptionAmount).format()} ${selectedPlan?.subscriptionPeriod}`}</del>&nbsp; {`AU $ ${numeral((1-checkCodeResponse.promo_code.discount_percentage*.01)*selectedPlan?.subscriptionAmount).format()} ${selectedPlan?.subscriptionPeriod}`}</span>
              : <span>{`AU $ ${numeral(selectedPlan?.subscriptionAmount).format()} ${selectedPlan?.subscriptionPeriod}`}</span>
            }
        </li>
        <li>
          <b>{isEmployer ? "Employer" : "Promo"} Code Details :&nbsp;</b>
          {promoDesc ? (
            <span style={{ color: 'red' }}>{promoDesc}</span>
          ) : (
            "You have not entered a valid code"
          )}
        </li>
        <li>
          <b>{isEmployer ? "Employer" : "Promo"} Code Expiry Date :&nbsp;</b>
          {endDate ? (
            <span>
              <span style={{ color: 'red' }}>{moment(endDate).local().format('Do MMM YYYY')}</span>
              <span>&nbsp;After this date you will be charged normal monthly fees unless you cancel prior to this date. You will be notified via email before this date.</span>
            </span>
          ) : (
            "N/A"
          )}
        </li>
      </ul>
    );
  };
  

  return (
    <PromoCodeActivationWrapper>
      <div className="content-container">
            <div className="promo-and-payment-container">
              <motion.div
                className="promo-code-entry-and-validate-and-activate"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                /* exit={{ opacity: 0 }} */
                transition={{ duration: 0.4, ease: "easeInOut" }}
              >
                <div className="promo-code-entry-and-validate">
                  <div className="promo-code-entry">
                    <Formsy ref={formRef} style={{ maxWidth: '300px'}}>
                      <TextInputWithFormsy
                        name="promo-code"
                        type="text"
                        validations={{
                          isExisty: false,
                          customValidation: checkForIsPromoCodeValid,
                        }}
                        required
                        value={ resolvedInputValue }
                        onChange={onChangePromoCode2}
                        placeholder={ isEmployerPlan
                          ? "enter code from employer" 
                          : "Promo Code"
                        }
                        label={ resolvedInputLabel }
                        disabled={ resolveInputDisabled }
                      />
                    </Formsy>
                  </div>
                  <div className="validation-message">
                      { 
                        (isEmployerPlan && activeEmployerCode.code) || (!isEmployerPlan && activeRoundUpCode.code)
                          ? null
                          : validationError && checkCode.length > 1 ? validationError : null
                        }
                  </div>
                </div>
                  <div className="activate-button-container">
                       <motion.div
                          key="activate-button"
                          //layout
                          //initial={{ opacity: 0, height: 0 }}
                          //animate={{ opacity: 1, height: "auto" }}
                          /* exit={{ opacity: 0, height: 0 }} */
                          //transition={{ duration: 0.4 }}
                        >
                          <ActionButton
                            text="Activate"
                            onClick={() => handleClick()}
                            color="#fff"
                            large={true}
                            disabled={
                              resolveActivateButton === false
                            }
                          />
                        </motion.div>
                       
                  </div>
              </motion.div>

              <motion.div
                className="promo-details-container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                /* exit={{ opacity: 0 }} */
                transition={{ duration: 0.4, ease: "easeInOut" }}
              >
                <AnimatePresence mode="sync">
                  {resolveCodeDetails && (
                    <motion.div
                      key="promo-details"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: "easeInOut" }}
                      style={{ overflow: "hidden" }}
                    >
                      {renderPromoCodeDetails()}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            </div>
      </div>
    </PromoCodeActivationWrapper>
  );
}

export default PromoCodeActivation;